import axios from 'axios'
import { BUSCAR_VENDA_URBANA } from '../types'
import { RESPONSE_ERROR_HANDLER_POSTPONE_HEADER } from '../../util/responseUtil'
import { URL } from '../../util/ambienteActions'

const OFFLINE_AWARE_CONFIG = {
  headers: {
    [RESPONSE_ERROR_HANDLER_POSTPONE_HEADER]: true
  }
}

export default function buscarVendaUrbanaPorId (idVendaUrbana, idEmpresa) {
  const url = `${URL}/vendas-urbanas/${idVendaUrbana}/empresa/${idEmpresa}`
  return dispatch => axios.get(url, OFFLINE_AWARE_CONFIG).then(
    response => dispatch({
      type: BUSCAR_VENDA_URBANA,
      payload: response.data
    })
  ).catch(erro => {
    if (!navigator.onLine || !erro.response) {
      return dispatch({ type: BUSCAR_VENDA_URBANA, payload: null })
    }
    throw erro
  })
}
